import repository from "@/plugins/axios/secureClient";

const nodeResource = "/node";

export default {
  getChildren(id, params) {
    return repository.get(`${nodeResource}/${id}/children/`, { params });
  },
  getOne(id) {
    return repository.get(`${nodeResource}/${id}/`);
  },
  getCreateTemplate(parentId, classId) {
    return repository.get(
      `${nodeResource}/${parentId}/create-template/${classId}`
    );
  },
  getCache(id) {
    return repository.get(`${nodeResource}/${id}/cache`);
  },
  setPublished(id, published, lang) {
    return repository.put(`${nodeResource}/${id}/set-published/`, {
      published,
      lang
    });
  },
  getSeqPub(id) {
    return repository.get(`${nodeResource}/${id}/sp`);
  },
  setSeqPub(id, seq, published) {
    return repository.put(`${nodeResource}/${id}/sp`, { seq, published });
  },
  create(parentId, classId, payload) {
    return repository.post(
      `${nodeResource}/${parentId}/add/${classId}/`,
      payload
    );
  },
  update(id, payload) {
    return repository.put(`${nodeResource}/${id}/`, payload);
  },
  delete(id) {
    return repository.delete(`${nodeResource}/${id}/`);
  }
};
